import { FC } from 'react';
import { useTranslations } from 'next-intl';
import { Calendar } from 'elements/DatePicker';
import { withDay } from 'elements/DatePicker/calendarGrid';
import { TimePicker } from 'elements/TimePicker';

interface Props {
  id: string;
  value: Date;
  onChange: (next: Date) => void;
}

// A day and a time of day picked together: the month calendar on top, the
// time underneath. For a memo's own date, in the composer's Date pill and
// the Change date dialog.
export const DateTimePicker: FC<Props> = ({ id, value, onChange }) => {
  const t = useTranslations();

  return (
    <div>
      <Calendar
        value={value}
        onSelect={(day) => onChange(withDay(value, day))}
      />
      <div className={styles.timeRow}>
        <label htmlFor={`${id}-time`} className={styles.timeLabel}>
          {t('memoComposer.calendar.time')}
        </label>
        <TimePicker
          id={`${id}-time`}
          label={t('memoComposer.calendar.time')}
          value={value}
          onChange={onChange}
          className={styles.time}
        />
      </div>
    </div>
  );
};

const styles = {
  timeRow:
    'flex items-center justify-between gap-3 border-t border-hairline px-3 py-2.5',
  timeLabel: 'text-sm text-ink-primary',
  time: 'w-[150px] text-sm',
};
